import { baseApi } from '../baseConfig';
import { List, SearchParams } from '../common.types';
import { ICompetency } from './CompetencyApi.types';

export const getCompetencies = (params: SearchParams) => baseApi.get('v3/list-competencies', { searchParams: params }).json<List<ICompetency>>();
